import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { useAppStore } from '@/stores/index';
import appSetting from '@/app-setting';

import HomeView from '../views/index.vue';
import { useAuthStore } from '@/stores/auth';
import { useAssetsStore } from '@/stores/assets';
import { useBranchesStore } from '@/stores/branches';

const routes: RouteRecordRaw[] = [
    // dashboard
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "finance" */ '../views/finance.vue')
    },
    {
        path: '/finance',
        name: 'finance',
        component: () => import(/* webpackChunkName: "finance" */ '../views/finance.vue')
    },
    // customers
    {
        path: '/customers/list',
        name: 'customers-list',
        component: () => import(/* webpackChunkName: "apps-customers-list" */ '../views/customers/list.vue')
    },
    {
        path: '/customers/:id/preview',
        name: 'customers-preview',
        component: () => import(/* webpackChunkName: "apps-customers-preview" */ '../views/customers/preview.vue')
    },
    {
        path: '/customers/add/:order_type',
        name: 'customers-add',
        component: () => import(/* webpackChunkName: "apps-customers-add" */ '../views/customers/add.vue')
    },
    {
        path: '/customers/:order_id/edit',
        name: 'customers-edit',
        component: () => import(/* webpackChunkName: "apps-customers-add" */ '../views/customers/add.vue')
    },
    {
        path: '/customers/sadad',
        name: 'customers-sadad',
        component: () => import(/* webpackChunkName: "apps-customers-sadad" */ '../views/customers/sadad.vue')
    },
    {
        path: '/customers/arboon',
        name: 'customers-arboon',
        component: () => import(/* webpackChunkName: "apps-customers-arboon" */ '../views/customers/arboon.vue')
    },
    // merchants
    {
        path: '/merchants/list',
        name: 'merchants-list',
        component: () => import(/* webpackChunkName: "apps-merchants-list" */ '../views/merchants/list.vue')
    },
    {
        path: '/merchants/:id/preview',
        name: 'merchants-preview',
        component: () => import(/* webpackChunkName: "apps-customers-preview" */ '../views/merchants/preview.vue')
    },
    {
        path: '/merchants/add/:order_type',
        name: 'merchants-add',
        component: () => import(/* webpackChunkName: "apps-merchants-add" */ '../views/merchants/add.vue')
    },
    {
        path: '/merchants/:order_id/edit',
        name: 'merchants-edit',
        component: () => import(/* webpackChunkName: "apps-customers-add" */ '../views/merchants/add.vue')
    },
    {
        path: '/merchants/sadad',
        name: 'merchants-sadad',
        component: () => import(/* webpackChunkName: "apps-merchants-sadad" */ '../views/merchants/sadad.vue')
    },
    {
        path: '/merchants/preview-sadad',
        name: 'merchants-preview-sadad',
        component: () => import(/* webpackChunkName: "apps-merchants-preview-sadad" */ '../views/merchants/preview-sadad.vue')
    },
    // branches
    {
        path: '/branches/list',
        name: 'branches-list',
        component: () => import(/* webpackChunkName: "apps-branches-list" */ '../views/branches/list.vue')
    },
    {
        path: '/branches/add',
        name: 'branches-add',
        component: () => import(/* webpackChunkName: "apps-branches-add" */ '../views/branches/add.vue')
    },
    {
        path: '/branches/:order_id/edit',
        name: 'branches-edit',
        component: () => import(/* webpackChunkName: "apps-branches-add" */ '../views/branches/add.vue')
    },
    {
        path: '/branches/:id/preview',
        name: 'branches-preview',
        component: () => import(/* webpackChunkName: "apps-branches-add" */ '../views/branches/preview.vue')
    },
    // other
    {
        path: '/other/list',
        name: 'other-list',
        component: () => import(/* webpackChunkName: "apps-other-list" */ '../views/other/list.vue')
    },
    {
        path: '/other/matching',
        name: 'other-matching',
        component: () => import(/* webpackChunkName: "apps-other-matching" */ '../views/other/matching.vue')
    },
    {
        path: '/other/expenses',
        name: 'other-expenses',
        component: () => import(/* webpackChunkName: "apps-other-expenses" */ '../views/other/expenses.vue')
    },
    {
        path: '/other/add',
        name: 'other-add',
        component: () => import(/* webpackChunkName: "apps-other-converter" */ '../views/other/add.vue')
    },
    {
        path: '/other/add',
        name: 'other-add',
        component: () => import(/* webpackChunkName: "apps-other-converter" */ '../views/other/add.vue')
    },
    {
        path: '/other/:order_id/edit',
        name: 'other-edit',
        component: () => import(/* webpackChunkName: "apps-other-converter" */ '../views/other/add.vue')
    },
    {
        path: '/other/:order_id/preview',
        name: 'other-preview',
        component: () => import(/* webpackChunkName: "apps-other-converter" */ '../views/other/preview.vue')
    },
    {
        path: '/other/edit-box',
        name: 'edit-box',
        component: () => import(/* webpackChunkName: "apps-other-edit-box" */ '../views/other/edit-box.vue'),
    },
    {
        path: '/other/to-borken',
        name: 'to-borken',
        component: () => import(/* webpackChunkName: "apps-other-to-borken" */ '../views/other/to-borken.vue'),
    },
    // products
    {
        path: '/products/list',
        name: 'products-list',
        component: () => import(/* webpackChunkName: "apps-products-list" */ '../views/products/list.vue')
    },
    {
        path: '/products/add/:type',
        name: 'products-add',
        component: () => import(/* webpackChunkName: "apps-products-add-piece" */ '../views/products/add.vue')
    },
    {
        path: '/products/add-set',
        name: 'products-add-set',
        component: () => import(/* webpackChunkName: "apps-products-add-set" */ '../views/products/add-set.vue')
    },
    {
        path: '/products/:product_id/preview',
        name: 'products-preview',
        component: () => import(/* webpackChunkName: "apps-products-preview-piece" */ '../views/products/preview.vue')
    },
    {
        path: '/products/:product_id/edit',
        name: 'products-edit',
        component: () => import(/* webpackChunkName: "apps-products-preview-piece" */ '../views/products/add.vue')
    },
    {
        path: '/products/preview-set',
        name: 'products-preview-set',
        component: () => import(/* webpackChunkName: "apps-products-preview-set" */ '../views/products/preview-set.vue')
    },
    // currencies
    {
        path: '/currencies/list',
        name: 'currencies-list',
        component: () => import(/* webpackChunkName: "apps-currencies-list" */ '../views/currencies/list.vue')
    },
    {
        path: '/currencies/transactions',
        name: 'currencies-transactions',
        component: () => import(/* webpackChunkName: "apps-currencies-transactions" */ '../views/currencies/transactions.vue')
    },
    {
        path: '/currencies/balances-list',
        name: 'currencies-balances-list',
        component: () => import(/* webpackChunkName: "apps-currencies-balances-list" */ '../views/currencies/balances-list.vue')
    },
    {
        path: '/currencies/prices',
        name: 'currencies-prices',
        component: () => import(/* webpackChunkName: "apps-currencies-prices" */ '../views/currencies/prices.vue')
    },
    {
        path: '/currencies/customer-debts',
        name: 'currencies-customer-debts',
        component: () => import(/* webpackChunkName: "apps-currencies-prices" */ '../views/currencies/customer-debts.vue')
    },
    {
        path: '/currencies/trader-debts',
        name: 'currencies-trader-debts',
        component: () => import(/* webpackChunkName: "apps-currencies-prices" */ '../views/currencies/merchant-debts.vue')
    },
    {
        path: '/reports/tax-declaration',
        name: 'tax-declaration-report',
        component: () => import(/* webpackChunkName: "apps-currencies-prices" */ '../views/reports/tax-declaration.vue')
    },
    // admin-conf
    {
        path: '/admin-conf/start-wizard',
        name: 'admin-conf-start-wizard',
        component: () => import(/* webpackChunkName: "apps-admin-conf-start-wizard" */ '../views/admin-conf/start-wizard.vue')
    },
    {
        path: '/admin-conf/branches-list',
        name: 'admin-conf-branches-list',
        component: () => import(/* webpackChunkName: "apps-admin-conf-branches-list" */ '../views/admin-conf/branches-list.vue')
    },
    {
        path: '/admin-conf/emp-list',
        name: 'admin-conf-emp-list',
        component: () => import(/* webpackChunkName: "apps-admin-conf-emp-list" */ '../views/admin-conf/emp-list.vue')
    },
    {
        path: '/admin-conf/customers-list',
        name: 'admin-conf-customers-list',
        component: () => import(/* webpackChunkName: "apps-admin-conf-customers-list" */ '../views/admin-conf/customers-list.vue')
    },
    {
        path: '/admin-conf/transactions',
        name: 'admin-conf-transactions',
        component: () => import(/* webpackChunkName: "apps-admin-conf-transactions" */ '../views/admin-conf/transactions.vue')
    },
    {
        path: '/admin-conf/merchent-trans-list',
        name: 'admin-conf-merchent-trans-list',
        component: () => import(/* webpackChunkName: "apps-admin-conf-merchent-trans-list" */ '../views/admin-conf/merchent-trans-list.vue')
    },
    {
        path: '/admin-conf/cust-trans-list',
        name: 'admin-conf-cust-trans-list',
        component: () => import(/* webpackChunkName: "apps-admin-conf-cust-trans-list" */ '../views/admin-conf/cust-trans-list.vue')
    },
    {
        path: '/admin-conf/customer-report',
        name: 'admin-conf-customer-report',
        component: () => import(/* webpackChunkName: "apps-admin-conf-cust-trans-list" */ '../views/admin-conf/cust-report.vue')
    },
    {
        path: '/admin-conf/merchant-report',
        name: 'admin-conf-merchant-report',
        component: () => import(/* webpackChunkName: "apps-admin-conf-cust-trans-list" */ '../views/admin-conf/merchant-report.vue')
    },
    //auth
    {
        path: '/auth/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login-email" */ '../views/auth/login.vue'),
        meta: { layout: 'auth' }
    },
    {
        path: '/auth/password-forget',
        name: 'forget-password',
        component: () => import(/* webpackChunkName: "login-email" */ '../views/auth/forget-password.vue'),
        meta: { layout: 'auth' }
    },
    {
        path: '/auth/password-reset',
        name: 'reset-password',
        component: () => import(/* webpackChunkName: "login-email" */ '../views/auth/reset-password.vue'),
        meta: { layout: 'auth' }
    },
    {
        path: '/auth/signup',
        name: 'signup',
        component: () => import(/* webpackChunkName: "auth-signup" */ '../views/auth/signup.vue'),
        meta: { layout: 'auth' }
    },
    {
        path: '/terms',
        name: 'terms',
        component: () => import(/* webpackChunkName: "auth-signup" */ '../views/auth/terms.vue'),
        meta: { layout: 'landing' }
    },
    {
        path: '/impersonate',
        name: 'impersonate',
        component: () => import(/* webpackChunkName: "auth-signup" */ '../views/auth/impersonate.vue'),
        meta: { layout: 'landing' }
    },

    // settings

    {
        path: '/users/user-account-settings',
        name: 'user-account-settings',
        component: () => import(/* webpackChunkName: "users-user-account-settings" */ '../views/users/user-account-settings.vue')
    },
    {
        path: '/settings/company',
        name: 'company-settings',
        component: () => import(/* webpackChunkName: "users-comp-account-settings" */ '../views/users/comp-account-settings.vue')
    },
    {
        path: '/settings/branch',
        name: 'branch-settings',
        component: () => import(/* webpackChunkName: "users-comp-account-settings" */ '../views/users/branch-settings.vue')
    },
    {
        path: '/settings/invoice-customer',
        name: 'invoice-customer-settings',
        component: () => import(/* webpackChunkName: "users-comp-account-settings" */ '../views/users/customer-invoice-settings.vue')
    },
    {
        path: '/settings/payment-methods',
        name: 'payment-methods',
        component: () => import(/* webpackChunkName: "users-comp-account-settings" */ '../views/payment-methods/list.vue')
    },
    {
        path: '/settings/taxes',
        name: 'taxes-settings',
        component: () => import(/* webpackChunkName: "users-comp-account-settings" */ '../views/taxes/list.vue')
    },
    {
        path: '/settings/subscription',
        name: 'subscription-settings',
        component: () => import(/* webpackChunkName: "users-comp-account-settings" */ '../views/users/subscription.vue')
    },
    {
        path: '/accounting/chart-of-accounts',
        name: 'chart-of-accounts',
        component: () => import(/* webpackChunkName: "users-comp-account-settings" */ '../views/accounting/chart-of-accounts/list.vue')
    },
    {
        path: '/accounting/journal-entries',
        name: 'journal-entries',
        component: () => import(/* webpackChunkName: "accounting-journal-entries" */ '../views/accounting/journal-entries/list.vue')
    },
    {
        path: '/services',
        name: 'services',
        component: () => import(/* webpackChunkName: "services" */ '../views/services/index.vue')
    }
];

const router = createRouter({
    history: createWebHistory(),
    linkExactActiveClass: 'active',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { left: 0, top: 0 };
        }
    }
});

router.beforeEach(async (to, from, next) => {
    const layout = to?.meta?.layout;
    const store = useAppStore();

    if (layout === 'landing') {
        store.setMainLayout('auth');

        next();
        return;
    }

    store.showInnerLoader = true;

    const assetsStore = useAssetsStore();
    const branchesStore = useBranchesStore();
    const authStore = useAuthStore();
    await authStore.loadUser();
    const loggedIn = authStore.authenticated;

    const setupPath = '/admin-conf/start-wizard';

    if (loggedIn) {
        await assetsStore.loadAssets();
        await branchesStore.loadBranches();

        store.setMainLayout('app');

        if (to.path != setupPath && assetsStore.assets.length === 0) {
            next(setupPath);
        } else {
            if (layout == 'auth' || (to.path == setupPath && assetsStore.assets.length > 0)) {
                next('/');
            } else {
                next();
            }
        }
    } else {
        store.setMainLayout('auth');

        if (layout == 'auth') {
            next();
        } else {
            // TODO: save last login page(email or phone) that the user used
            next('/auth/login');
        }
    }
});
router.afterEach((to, from, next) => {
    appSetting.changeAnimation();

    const store = useAppStore();
    store.showInnerLoader = false;
    // close modals
    store.showAddCustomerOrder = false;
    store.showAddMerchantOrder = false;
    store.showAddOtherOrder = false;
    store.showAddBranchOrder = false;
});
export default router;
